import { h } from 'vue';

export default ('v-style', {
  render() {
    return h('style', this.$slots.default)
  }
});